import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function agents() {
    return {
        index,
        create,
        update,
        getAgentDetail,
        deleteAgent
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`agent/search${params}`);
    }

    function getAgentDetail(id) {
        return axiosInstance.get(`agent/get?id=${id}`);
    }

    function create(payload) {
        return axiosInstance.post(`agent/create`, JSON.stringify(payload));
    }

    function update(payload) {
        return axiosInstance.patch(`agent/update`, JSON.stringify(payload));
    }

    function deleteAgent(payload) {
        return axiosInstance.delete(`agent/delete`, {
            data: JSON.stringify(payload)
        });
    }
}
